import React from 'react';
import { Icon } from '../Icon';

export const PaginationControl = ({
  nextPage,
  prevPage,
  loading,
  startIndex,
  endIndex,
  count,
  ...props
}) => (
  // (nextPage || prevPage) &&
  <nav className="pagination-wrapper">
    {loading ? (
      <span>
        <Icon name="loader" spin />
      </span>
    ) : (
      startIndex > 0 &&
      endIndex > 0 && (
        <span>
          {startIndex}-{endIndex}
          {count ? ` of ${count}` : ''}
        </span>
      )
    )}
    <ul className="pagination">
      <li className="page-item">
        <button
          type="button"
          className="page-link"
          onClick={prevPage}
          disabled={!prevPage || loading}
        >
          <Icon name="chevron-left" />
        </button>
      </li>

      <li className="page-item">
        <button
          type="button"
          className="page-link"
          onClick={nextPage}
          disabled={!nextPage || loading}
        >
          <Icon name="chevron-right" />
        </button>
      </li>
    </ul>
  </nav>
);
